// @ts-nocheck
import { Column } from 'react-table'
import { PaymentMethodActionsCell } from './PaymentMethodActionsCell'
import { PaymentMethodSelectionCell } from './PaymentMethodSelectionCell'
import { PaymentMethodCustomHeader } from './PaymentMethodCustomHeader'
import { PaymentMethodSelectionHeader } from './PaymentMethodSelectionHeader'
import { PaymentMethod } from '../../core/_models'
import { FormattedMessage } from 'react-intl'
import { PaymentMethodInfoCell } from './PaymentMethodInfoCell'

const paymentmethodsColumns: ReadonlyArray<Column<PaymentMethod>> = [
  {
    Header: (props) => <PaymentMethodSelectionHeader tableProps={props} />,
    id: 'selection',
    Cell: ({ ...props }) => <PaymentMethodSelectionCell id={props.data[props.row.index].id} />,
  },
  {
    Header: (props) => (
      <PaymentMethodCustomHeader 
        tableProps={props} 
        title={<FormattedMessage id='PAYMENTMETHOD.TABLE.COLUMN.METHODNAME' defaultMessage='Method Name' />} 
        className='min-w-125px' 
      />
    ),
    id: 'method_name',
    accessor: 'method_name',
  },
  {
    Header: (props) => (
      <PaymentMethodCustomHeader 
        tableProps={props} 
        title={<FormattedMessage id='PAYMENTMETHOD.TABLE.COLUMN.ACCOUNTDETAILS' defaultMessage='Account Details' />} 
        className='min-w-150px' 
      />
    ),
    id: 'account_details',
    accessor: 'account_details',
  },
  {
    Header: (props) => <PaymentMethodCustomHeader tableProps={props} title={<FormattedMessage id='PAYMENTMETHOD.TABLE.COLUMN.IMAGE' defaultMessage={"Account Image"} />} className='min-w-125px' />,
    id: 'account_image',
    Cell: ({...props}) => <PaymentMethodInfoCell paymentmethod={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <PaymentMethodCustomHeader 
        tableProps={props} 
        title={<FormattedMessage id='PAYMENTMETHOD.TABLE.COLUMN.STATUS' defaultMessage='Status' />} 
        className='min-w-100px' 
      />
    ),
    id: 'status',
    accessor: 'status',
    Cell: ({ value }) => {
      const renderStatusBadge = () => {
        if (value === 1) {
          return <span className="badge badge-success">Active</span>;
        } else if (value === 0) {
          return <span className="badge badge-danger">De-Active</span>;
        }
        return null;
      };
      return renderStatusBadge();
    },
  },
  {
    Header: (props) => (
      <PaymentMethodCustomHeader 
        tableProps={props} 
        title={<FormattedMessage id='TABLE.GENERAL.ACTION' defaultMessage='Action' />} 
        className='text-end min-w-100px' 
      />
    ),
    id: 'actions',
    Cell: ({ ...props }) => <PaymentMethodActionsCell id={props.data[props.row.index].id} />,
  },
]

export { paymentmethodsColumns }
